import {defineMessages} from 'react-intl'

export default defineMessages({
    goBack: {
        id: 'containers.AiPage.goBack',
        defaultMessage: 'Explore more voices',
    },
    generateVoice: {
        id: 'containers.AiPage.generateVoice',
        defaultMessage: 'Generate',
    },
    scriptPlaceholder: {
        id: 'containers.AiPage.scriptPlaceholder',
        defaultMessage: 'Enter your script here',
    },
    processing: {
        id: 'containers.AiPage.processing',
        defaultMessage: 'Processing...',
    },
    download: {
        id: 'containers.AiPage.download',
        defaultMessage: 'Download',
    },
    select: {
        id: 'containers.AiPage.select',
        defaultMessage: 'Select',
    },
    nativeIn: {
        id: 'containers.AiPage.nativeIn',
        defaultMessage: '{age} years old {gender}, native {languages} speaker',
    },
    unlock: {
        id: 'containers.AiPage.unlock',
        defaultMessage: 'Unlock',
    },
    unlocking: {
        id: 'containers.AiPage.unlocking',
        defaultMessage: 'Unlocking...',
    },
    suggestionLoading: {
        id: 'containers.AiPage.suggestionLoading',
        defaultMessage: 'Loading...',
    },
    suggestionButton: {
        id: 'containers.AiPage.suggestionButton',
        defaultMessage: 'Suggest script',
    },
})
